import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import { Logo } from 'containers/Logo/Logo';
import type { FlysiteUrls } from 'hooks/useFlysiteUrls';

import './Powered.scss';

const PoweredComponent = ({ flysiteUrl }: FlysiteUrls) => (
  <div className="Powered">
    <p className="Powered-text">Powered by</p>
    <a href={flysiteUrl} rel="noopener noreferrer" target="_blank">
      <Logo className="Powered-logo" size="small" />
    </a>
  </div>
);

const Powered = WithFlysiteUrls(PoweredComponent);

export { Powered };
